var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "home",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.06,59.5L41.24,325.31c-3.49,3.49-5.44,8.21-5.44,13.15v228.9c0,10.27,8.32,18.59,18.59,18.59h166.18c10.27,0,18.59-8.32,18.59-18.59v-135.2c0-10.27,8.32-18.59,18.59-18.59h125.06c10.27,0,18.59,8.32,18.59,18.59v135.2c0,10.27,8.32,18.59,18.59,18.59h165.62c10.27,0,18.59-8.32,18.59-18.59V341.21c0-4.89-1.93-9.59-5.37-13.07L333.43,59.57C326.18,52.24,314.35,52.21,307.06,59.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.29ed0c9726d27343ff0e3afc3776d792.svg";
export { ForwardRef as ReactComponent };